import server from "@/plugins/http.js";
// 是否领取过注册福利
export function regWelfare(params) {
    return server({
        url: `/api/app/activity/regWelfare`,
        method: 'get',
        params: params,
    })
}

// 查询设备
export function instancelist(params) {
    return server({
        url: '/api/app/instance/list',
        method: 'get',
        params: params,
    })
}
// 查询分组
export function groupList(params) {
    return server({
        url: '/api/app/group/v2/instance/list',
        method: 'get',
        params: params,
    })
}

// 获取设备截图改版
export function hsOrBdScreenshot(data) {
    return server({
        url: '/api/admin/app/instance/hsOrBdScreenshot',
        method: 'post',
        data: data
    })
}

export function hsOrBdScreenshot_info(data) {
    return server({
        url: '/api/admin/app/instance/hsOrBdScreenshot-info',
        method: 'post',
        data: data
    })
}

// 获取STS临时token
export function uploadgetSts(params) {
    return server({
        url: '/api/app/upload/getSts',
        method: 'get',
        params: params,
    })
}
// 查询用户信息
export function userinfo(params) {
    return server({
        url: '/api/app/user/info',
        method: 'get',
        params: params,
    })
}
// 修改用户信息
export function update(data) {
    return server({
        url: '/api/app/user/update',
        method: 'post',
        data: data,
    })
}
// 系统参数
export function sysConfigByConfigKey(params) {
    return server({
        url: 'api/common/getSysConfigByConfigKey',
        method: 'get',
        params: params
    })
}
// 领取注册福利设备
export function activityReceive(data) {
    return server({
        url: 'api/app/activity/receive',
        method: 'post',
        data: data
    })
}
// 活动提示
export function activityreminder(params) {
    return server({
        url: '/api/app/activity/reminder',
        method: 'get',
        params: params,
    })
}
// 消息未读数量
export function unread(params) {
    return server({
        url: 'api/app/message/unread',
        method: 'get',
        params: params
    })
}
// 消息中心
export function messagelist(data) {
    return server({
        url: '/api/app/message/list',
        method: 'post',
        data: data,
    })
}
// 读取所有未读消息
export function alreadyMessage(data) {
    return server({
        url: '/api/app/message/readAll',
        method: 'post',
        data: data,
    })
}
